import styled, { css } from "styled-components"
import { theme } from "../../styled/theme"

export const WTLink = styled.a`
  position: fixed;
  width: 60px;
  height: 60px;
  bottom: 40px;
  right: 40px;
  background-color: #25D366;
  color: #FFF;
  border-radius: 50px;
  text-align: center;
  font-size: 40px;
  box-shadow: 1px 1px 2px #888;
  z-index: 1000;
  
  :hover {
    opacity: 0.9;
    background-color: #188741;
    box-shadow: rgba(99, 99, 99, .2) 0px 2px 8px 0px;
  }
  
  svg {
    margin-top: -5px;
    vertical-align: center !important;
  }
`;
